import { useState } from 'react';
import { AccountsPackItemClient, AccountsPackItemDTO, ApiResponse_string, SearchRequestDTO_AccountsPackItemSearchRequestDTO, BulkDownloadRequestDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useAccountsPackItemApi = () => {
    const apiClient = new AccountsPackItemClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: AccountsPackItemDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createAccountsPackItem(data);
        } catch (err: any) {
            setError(err.message || 'Error creating AccountsPackItem');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: AccountsPackItemDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateAccountsPackItem(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating AccountsPackItem');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getAccountsPackItemById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching AccountsPackItem');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchAccountsPackItems(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching AccountsPackItems');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteAccountsPackItem(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting AccountsPackItem');
        } finally {
            setIsLoading(false);
        }
    };

    const extract = async (
        filters: any
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.exportAccountsPackItems(filters);
        } catch (err: unknown) {
            handleHookError(err, 'Error exporting AccountsPackItems', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const bulkDownload = async (accountsPackItemIds: string[], userEmail: string, userName: string): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            const request: BulkDownloadRequestDTO = {
                accountsPackItemIds,
                userEmail,
                userName
            };
            return await apiClient.bulkDownloadAccountsPackItems(request);
        } catch (err: any) {
            setError(err.message || 'Error requesting bulk download');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, extract, remove, bulkDownload, isLoading, error };
};